<template>
  <div class="main-content sn-content">
    <el-card class="box-card">
      <el-row :gutter="30">
        <el-col :xs="24" :md="12" :lg="8">
          <el-card shadow="hover" class="console-card">
            <div class="console-card-box">
              <el-row type="flex" justify="space-between">
                <p class="console-card-box-title">账户</p>
                <i class="el-icon-collection icon-right"></i>
              </el-row>
              <el-divider></el-divider>
              <div class="console-card-box-row">

                <div>
                  <span class="width-150">账户总余额<span class="unit">(元)</span>：</span>
                  <span :class="{danger:userBalance < 0, 'value-row':true}">{{userBalance}}</span>
                </div>
                <router-link :to="{path:'/account/charge'}" style="color: #FF6B00">去充值</router-link>

              </div>
              <div v-if="userRechargeLogWithExpireTimeList.length > 0" class="console-card-box-row"
                   style="justify-content:flex-start">
                <span class="width-200">时效金余额<span class="unit">(元)</span>：</span>
                <div v-for="i in userRechargeLogWithExpireTimeList"
                     style="padding: 10px;background: #efefef;border: 1px dotted #ccc;margin-right: 10px">
                  <div><span class="value-row">{{i.remainAmount}}</span> 剩余</div>
                  <el-statistic
                    ref="statistic"
                    format="DD天HH小时mm分钟ss秒"
                    :value="i.expireTime"
                    :value-style="{fontSize:'12px',padding:'0'}"
                    title=""
                    time-indices
                  >
                  </el-statistic>

                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <el-card shadow="hover" class="console-card">
            <div class="console-card-box">
              <el-row type="flex" justify="space-between">
                <p class="console-card-box-title">授权码</p>
                <i class="el-icon-coordinate icon-right"></i>
              </el-row>
              <el-divider></el-divider>
              <div class="console-card-box-row">
                <div>
                  <span class="width-100">授权配额<span class="unit">(个)</span>:</span>
                  <span class="value-row">{{userConfig.snCnt}}<span class="unit">(已使用)</span></span>
                  <span class="value-row">&nbsp;/&nbsp;</span>
                  <span class="value-row">{{userConfig.snQuota}}<span class="unit">(总配额)</span></span>
                </div>
                <div>
                  <!-- <router-link :to="{path:'/sn/add'}" style="color: #FF6B00">
                    申请授权码
                  </router-link> -->
                  <router-link :to="{path:'/sn/index'}" style="color: #FF6B00">
                    查看授权码
                  </router-link>
                </div>
              </div>
              <div class="console-card-box-row">
                <div>
                  <span class="width-100">SDK授权码<span class="unit">(个)</span>:</span>
                  <span class="value-row">{{userConfig.sdkidCnt}}<span class="unit">(已使用)</span></span>
                </div>
                <div>
                  <router-link :to="{path:'/sdkLicence/index'}" style="color: #FF6B00">
                    查看SDK授权码
                  </router-link>
                </div>
              </div>
            </div>
            <el-row type="flex" justify="start" align="middle" class="icon-row">
              <div>
                <router-link :to="{path:'/sn/add'}" style="color: #FF6B00">
                  申请授权码
                </router-link>
                <el-divider direction="vertical"></el-divider>
                <router-link :to="{path:'/sdkLicence/add'}" style="color: #FF6B00">
                  申请SDK授权码
                </router-link>
              </div>
            </el-row>
          </el-card>
        </el-col>

        <el-col :xs="24" :md="12" :lg="8">
          <el-card shadow="hover" class="console-card">
            <div class="console-card-box">
              <el-row type="flex" justify="space-between">
                <p class="console-card-box-title">托管应用</p>
                <i class="el-icon-set-up icon-right"></i>
              </el-row>
              <el-divider></el-divider>
              <div class="console-card-box-row">
                <div>
                  <span class="width-100">应用配额<span class="unit">(个)</span>:</span>
                  <span class="value-row">{{userConfig.appliCnt}}<span class="unit">(已使用)</span></span>
                  <span class="value-row">&nbsp;/&nbsp;</span>
                  <span class="value-row">{{appliConfigs[1]}}<span class="unit">(总配额)</span></span>
                </div>
              </div>
              <div class="console-card-box-row">
                <div>
                  <span class="width-100">应用并发<span class="unit">(个)</span>:</span>

                  <span class="value-row">{{appliUsageInfo.runningCnt}}<span class="unit">(已使用)</span></span>
                  <span class="value-row">&nbsp;/&nbsp;</span>
                  <span class="value-row">{{appliConfigs[2]}}<span class="unit">(总并发)</span></span>
                  <span class="value-row">     <i @click="getAppliRunningCnt()" class="el-icon-refresh"
                                                  style="cursor: pointer;"></i></span>
                </div>
              </div>
              <div class="console-card-box-row">
                <div>
                  <span class="width-100">应用存储<span class="unit">(GB)</span>:</span>
                  <span class="value-row">≈{{(userConfig.appliUsedStorage / 1024 /1024 /1024).toFixed(2)}}<span class="unit">(已使用)</span></span>
                  <span class="value-row">&nbsp;/&nbsp;</span>
                  <span class="value-row">{{appliConfigs[0]}}<span class="unit">(总配额)</span></span>
                </div>
              </div>
            </div>
            <el-row type="flex" justify="start" align="middle" class="icon-row">
              <div>
                <router-link :to="{path:'/appli/index'}" style="color: #FF6B00">
                  查看应用
                </router-link>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="gotoAppliAdd" type="text" style="color: #FF6B00;padding: 0;">添加应用</el-button>
              </div>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <p v-if="userBalance && userBalance < Number(lineOfCreditInfo.lineOfCredit)" class="balance-tip">
      温馨提示：您的余额已不足{{lineOfCreditInfo.lineOfCredit}}元，为了不影响您的使用，请及时充值。
      <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
        【去充值】
      </router-link>
    </p>
    <p v-else-if="userBalance && userBalance < 100 && userBalance > 0" class="balance-tip">温馨提示：您的余额即将不足，为了不影响您的使用，请及时充值。
      <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
        【去充值】
      </router-link>
    </p>
    <p v-else-if="userBalance && userBalance <= 0 && (!$store.state.voucherBalance>0)" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
      <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
        【去充值】
      </router-link>
    </p>
    <p style="color: #FF6B00;font-size: 16px;line-height: 26px;">
      <i class="el-icon-bell" style="font-weight: 600;font-size: 20px;"></i>
      本网站平台（LarkXR推流软件服务和应用托管服务）是面向新用户的免费测试平台，已不提供在线充值服务，如有具体项目需求请联系平行云商务或拨打热线 <span style="color:#409EFF;">400-678-1024</span> 获取帮助。<br/>如果您仍打算自助使用3D/XR应用公网推流软件，请移步平行云新产品 <el-link  type="primary" :underline="false" href="https://www.immershare.com/" style="color:#FF6B00;font-size: 16px;font-weight:600;" target="_blank"> ImmerShare </el-link>，面向各类3D/XR应用的一键安装工具。每个月仅需59.9元，即可畅享3D应用“极简秒分享，一键推公网”的极致体验。<br/>新用户注册即赠送7天免费使用权益：<el-link  type="primary" :underline="false" href="https://www.immershare.com/" style="color:#409EFF;font-size: 16px;" target="_blank"> www.immershare.com </el-link>
    </p>
    <el-dialog center title="温馨提示" :visible="(tipDialogVisible && !hasTipBalance0)" width="350px"
               @close="closeBalanceDialog" custom-class="paraverse-dialog" top="35vh">
      <div>
        <p style="text-align: center;">
          <i class="el-icon-warning" style="color: #E6A23C;font-size: 20px;vertical-align: top;"></i>
          &nbsp;您的余额不足，请及时充值。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toChargeFn" size="small">去充值</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'
  import Calculation from '@/utils/calculation'

  export default {
    components: {PageComponent},
    data() {
      return {
        userConfig: {},
        appliConfigs: [],
        cloudSnList: [],
        userBalance: 0,
        tipDialogVisible: false,
        hasTipBalance0: localStorage.getItem('hasTipBalance0') || false, //是否已经提示过余额不足
        lineOfCreditInfo: {//费用预警阈值信息
          lineOfCredit: 10
        },
        appliUsageInfo: {
          totalSize: '-',
          appliCnt: '-',
          runningCnt: '-'
        },
        userRechargeLogWithExpireTimeList: []
      }
    },
    created() {
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getAppliRunningCnt: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        this.getRequest('/poc/hostAppli/getRunningCnt', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              console.log(resp.data.result)
              this.appliUsageInfo.runningCnt = resp.data.result.runCntOnAppKey.runCnt;
              //this.hostAppliCnt = resp.data.result.total;
              //TODO:查询poc_product表查询具体的配合信息
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      uacUserConfig: function () {
        this.getRequest('/uacUserConfig/getInfo', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {

              this.userConfig = resp.data.result;
              this.appliConfigs = this.userConfig.appliQuota.split(",");

              this.userBalance = Calculation.add(parseFloat(this.userConfig.permanentBalance ? this.userConfig.permanentBalance : 0)
                , parseFloat(this.userConfig.timeLimitedBalance ? this.userConfig.timeLimitedBalance : 0));

              this.$store.commit('setUserBalance', this.userBalance);
              window.localStorage.setItem('balance', this.userBalance)
              // 余额不足时弹窗提示
              if (this.userBalance < 0) {
                this.tipDialogVisible = true;
              }
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      getHasExpireDateList: function () {
        this.getRequest('/ofcRechargeLog/getHasExpireDateList', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userRechargeLogWithExpireTimeList = resp.data.result;
              console.log(this.userRechargeLogWithExpireTimeList)

            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      closeBalanceDialog() {
        this.tipDialogVisible = false;
        this.hasTipBalance0 = true;//表示 弹出过 余额不足的提示弹窗
        window.localStorage.setItem('hasTipBalance0', true);
      },
      toChargeFn() {
        this.closeBalanceDialog();
        this.$router.push('/account/charge');
      },
      // 获取费用预警阈值
      getOutofcredititem() {
        this.getRequest('/ofcOutOfCreditItem/getByUserId', {userId: this.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000 && resp.data.result) {
              this.lineOfCreditInfo = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      gotoAppliAdd() {
        //判断用户余额是否少于20
        if (parseInt(this.userBalance) < 20) {
          var that = this;
          this.$confirm('余额不足20，无法创建应用，请选择"去充值"。如果想获取额外支持，拨打热线电话：4006781024', '温馨提示', {
            confirmButtonText: '去充值',
            cancelButtonText: '关闭',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({path: '/account/charge'})
          }).catch(() => {

          });
        } else {
          this.$router.push({path: '/appli/add'})
        }
      },
    },
    mounted: function () {
      this.uacUserConfig();
      this.getOutofcredititem();
      this.getAppliRunningCnt();
      this.getHasExpireDateList()
    },
    beforeDestroy() {

    }
  }
</script>
<style lang="scss" scoped>
  .balance-tip {
    color: #F56C6C;
  }

  .el-divider--horizontal {
    margin: 5px 0 !important;
  }

  .console-card {
    min-height: 200px;
    position: relative;

    &-box {
      position: relative;

      &-title {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }

      &-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;

        > div {
          vertical-align: middle;

          > span:nth-of-type(1) {
            display: inline-block;
          }

          .value-row {
            display: inline-block;
            font-size: 24px;
            // font-weight: 600;
            // color: #333;
            color: #FF6B00;
            vertical-align: middle;
          }
        }
      }
    }

    .icon-row {
      width: 100%;
      position: absolute;
      bottom: 12px;
    }

    .icon-right {
      display: inline-block;
      font-size: 20px;
    }

    .width-100 {
      width: 100px;
    }

    .width-120 {
      width: 120px;
    }
  }
</style>
